var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSp = function SvgSp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 44"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 6.5,
    y: 5,
    fill: "#fff",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.5 26.175v-10.35a.83.83 0 0 1 .246-.582.833.833 0 0 1 1.036-.112l4.13 2.615a.83.83 0 0 1 .402.704v5.1a.82.82 0 0 1-.402.705l-4.13 2.615a.833.833 0 0 1-1.282-.695m9.586-.763v-8.85a.82.82 0 0 1 .492-.753.84.84 0 0 1 .896.139l2.171 1.873a.82.82 0 0 1 .28.617v5.1a.82.82 0 0 1-.28.616l-2.171 1.873a.836.836 0 0 1-1.255-.166.8.8 0 0 1-.133-.448zm7.613-.763v-7.35a.82.82 0 0 1 .524-.767.84.84 0 0 1 .914.2l1.105 1.097a.82.82 0 0 1 .258.595v5.1a.82.82 0 0 1-.258.595l-1.105 1.097a.835.835 0 0 1-.913.2.83.83 0 0 1-.525-.767"
  })));
};
export default SvgSp;